import React, { useState, useEffect } from 'react';
import { collection, query, where, orderBy, getDocs } from 'firebase/firestore';
import { db } from '../firebase/config';
import { useAuthContext } from '../hooks/useAuthContext';
import './MyOrders.css';

const MyOrders = () => {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const { user } = useAuthContext(); // Destructure user from useAuthContext

  useEffect(() => {
    const fetchOrders = async () => {
      try {
        if (!user) return; // Check if user is authenticated

        const ordersRef = collection(db, 'orders');
        const q = query(
          ordersRef,
          where('userId', '==', user?.uid), // Fetch orders for the logged-in user
          orderBy('createdAt', 'desc')
        );

        const querySnapshot = await getDocs(q);
        const ordersData = querySnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));

        setOrders(ordersData);
      } catch (error) {
        console.error('Error fetching orders:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchOrders();
  }, [user]);

  const formatDate = (timestamp) => {
    return new Date(timestamp.toDate()).toLocaleDateString();
  };

  if (loading) {
    return (
      <div className="loading-container">
        <div className="loading-spinner-overlay">
        <div className="loading-spinner"></div>
        </div>
      </div>
    );
  }

  return (
    <div className="orders-container">
      <h1 className="page-title">My Orders</h1>

      <div className="orders-grid">
        {orders.map((order) => (
          <div key={order.id} className="order-card">
            <div className="order-header">
              <span className="order-id">Order #{order.id.slice(0, 8)}</span>
              <span className={`status-badge status-${order.status}`}>
                {order.status}
              </span>
            </div>

            <div className="order-content">
              {/* // Show more details about the orders for authenticated users */}
              <div className="info-group">
                <p className="info-label">Customer</p>
                <p className="info-value">{order.customerName}</p>
                <p className="info-value">{order.customerEmail}</p>
              </div>

              <div className="info-group">
                <p className="info-label">Order Date</p>
                <p className="info-value">{formatDate(order.createdAt)}</p>
              </div>

              <div className="info-group">
                <p className="info-label">Total Amount</p>
                <p className="info-value">&#8358;{order.totalAmount.toFixed(2)}</p>
              </div>

              <div className="info-group">
                <p className="info-label">Items</p>
                <ul className="items-list">
                  {order.items.map((item, index) => (
                    <li key={index}>
                      {item.name} x{item.quantity} - ${item.price}
                      <br />
                      <small>Size: {item.size}, Color: {item.color}</small>
                    </li>
                  ))}
                </ul>
              </div>

              {order.trackingNumber && (
                <div className="info-group">
                  <p className="info-label">Tracking Number</p>
                  <p className="info-value">{order.trackingNumber}</p>
                </div>
              )}

              <div className="info-group">
                <p className="info-label">Shipping Address</p>
                <p className="info-value">
                  {order.deliveryAddress.street}
                  <br />
                  {order.deliveryAddress.city}, {order.deliveryAddress.state}
                  <br />
                  {order.deliveryAddress.country}, {order.deliveryAddress.postalCode}
                </p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default MyOrders;